import { Link } from 'react-router-dom';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import * as graphql from '@treams/treams-network';
import { Paragraph, tokens } from '@treams/treams-ui';

const Bar = styled(Link)<{ completed?: boolean; selected?: boolean }>`
	display: block;
	height: 4px;
	background: ${(props) =>
		props.selected
			? '#18D9D9'
			: props.completed
				? props.theme.colors.primary
				: tokens.border.subtle};
	width: 50px;
`;

export default function ProgressBar(props: {
	selected?: string;
	response: graphql.EngagementResponse;
	secret?: string;
}) {
	if (props.response.request.questions.length > 10) {
		return (
			<Flex>
				<Paragraph color="slateBlue">
					{props.response.request.questions.findIndex(({ id }) => id === props.selected) + 1}/
					{props.response.request.questions.length}
				</Paragraph>
			</Flex>
		);
	}

	return (
		<Flex>
			{props.response.request.questions.map((question, i) => {
				const completed = props.response.answers?.some(
					(answer) => answer.questionID === question.id,
				);

				const to = `/engagement/${props.response.id}/${question.id}${
					props.secret ? '?secret=' + props.secret : ''
				}`;

				return (
					<Box key={i} ml={i === 0 ? 0 : 1}>
						<Bar
							completed={completed}
							selected={props.selected === question.id}
							to={i < props.response.answers.length + 1 ? to : undefined}
						/>
					</Box>
				);
			})}
		</Flex>
	);
}
